import { LANDING_URL } from "App.const";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Store } from "state/store";

export type InitScreenProps = {
  store: Store;
};
export const InitScreen = ({ store }: InitScreenProps) => {
  const navigate = useNavigate();
  useEffect(() => {
    store.bootstrap();
    navigate(LANDING_URL, { replace: true });
  }, [store, navigate]);
  return <></>;
};
